export enum BatchPurpose {
  FIRE = 1,
  TURN = 2,
  CLEARING = 3,
  REGENERATION = 4,
  CLEANING = 5,
  MEADOW = 6,
  SILVESTRIAN_TREATMENT = 7,
  FIREWALL = 8,
  POWER_LINE_INSTALLMENT = 9,
  PHONE_LINE_INSTALLMENT = 10,
  HIGHWAY_CONSTRUCTION = 11,
  ROAD_EXTENSION = 12,
  POWER_LINE_SECURITY_BELT = 13,
  FIREWALL_BELT_OPENING = 14,
  TRACK_OPENING = 15,
  AMUSEMENT_PARK_BUILD = 16,
  PATH_BUILD = 17,
  ROAD_BUILD = 18,
  FIREWATCH_TOWER_BUILD = 19,
  PATH_EXPANSION = 20,
  QUARRY_USE = 21,
  CLAY_EXTRACTION = 22,
  OCCUPATIONS = 23,
  CLEAR_AND_PRUNING = 24,
  DEPOSIT_LOSS = 25,
  PLAGUE = 26,
  KNOCK_DOWN = 27,
  DRY_TREES = 28,
  KNOCK_DOWN_CLEAR = 29,
  KNOCK_DOWN_FIRE = 30,
  TEMPORARY = 31,
  TEMPORARY_FIRE = 32,
  OTHER = 33,
  EXPROPRIATION = 34,
  BURSAPHELENCHUS_ORDER_COMPLIANCE = 35,
  REPLANT_DISTANCE_ADAPTATION = 36,
  CLEARING_2 = 37
}
